import React from 'react';
import moment from 'moment';
import QrCodeDrawer from 'admin/components/molecules/QrCodeDrawer';

export const downloadQrCodeImage = (name) => {
  const qrcodeFileName = `${name}_${moment().format('YYYYMMDDHHmmss')}.png`;
  const link = document.createElement('a');
  const canvas = document.getElementById('canvas');
  const event = new MouseEvent('click', { view: window, bubbles: true, cancelable: false });
  link.textContent = 'download image';
  link.href = canvas.toDataURL();
  link.download = qrcodeFileName;
  link.dispatchEvent(event);
};

const openQrCodePopup = (uri, fileName, popup, openAlertModal) => {
  openAlertModal({
    body: <QrCodeDrawer uri={uri} ref={popup} />,
    useCancel: true,
    confirmText: 'ダウンロード',
    onConfirm: () => downloadQrCodeImage(fileName),
  });
};

export default openQrCodePopup;
